module.exports = __webpack_public_path__ + "img/blend3icon3.d692760d.png";